import { useEffect, useState } from "react";
import moment from "moment";
import ArrowBackIosNewSharpIcon from "@mui/icons-material/ArrowBackIosNewSharp";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { ListaEmpleadosHoras } from "../components/ListaEmpleadosHoras";
import { fetchVistaHorarios } from "../Api/fetchVistaHorarios";
import { fetchBitacora } from "../Api/fetchBitacora";
import { UseAdmin, UseUser, UseAuth } from "../hooks";
import { VERSION_APP } from "../utilities";
import { Card } from "../components/Card/Card";
import { CalendarIcon } from "../components/shared/CalendarIcon";
import { BtnPill } from "../components/Buttons/BtnPill";
import { Input } from "antd";
import { icons } from "../const/icons";

import "../theme/HorariosView.css";

export const ListadeHorarios = () => {
  const currentDate = moment();
  const currentWeekNumber = currentDate.week();
  const currentYear = currentDate.format("YYYY");
  const [listEmpleados, setListEmpleados] = useState([]);
  const [changeDate, setChangeDate] = useState("LUN");
  const [selectedOption, setselectedOption] = useState(currentWeekNumber);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { employeeId, mail, device } = UseUser();
  const { branchFiSucursalId, brandfiBiId, branchFcNombre, brandfiMarcaId, branchFiPaisId } =
    UseAdmin();
  const { uniqueId } = UseAuth();

  const weekStartDate = moment().weekYear(currentYear).week(currentWeekNumber).startOf("week");
  const weekEndDate = moment().weekYear(currentYear).week(currentWeekNumber).endOf("week");

  useEffect(() => {
    fetchDataHorario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption, brandfiBiId, branchFiSucursalId]);

  const nextWeekNumber = moment().add(1, "week").week();
  const previousWeekNumber = moment().subtract(1, "week").week();

  const fetchDataHorario = async () => {
    const week = selectedOption === null ? currentWeekNumber : selectedOption;
    const dateConsult = `${currentYear}${week}`;

    if (dateConsult !== null && brandfiBiId !== null && branchFiSucursalId !== null) {
      setIsLoading(true);
      const onFailure = ({ error, config }) => {
        getBitacora(error, config);
        setIsLoading(false);
      };

      const onSuccess = ({ data, config }) => {
        getBitacora(data, config);
        setListEmpleados(data.body);
        setIsLoading(false);
      };

      fetchVistaHorarios(dateConsult, brandfiBiId, branchFiSucursalId)
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const getBitacora = async (dataResponse, saveRequest) => {
    const deviceWeb = `${uniqueId}-${device}`;
    const key = `${uniqueId}-${device}-${employeeId}`;
    const obtenerFechaEnFormato = () => {
      const ahora = moment();
      const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
      return fechaEnFormato;
    };

    const fechaActualEnFormato = obtenerFechaEnFormato();

    if (brandfiMarcaId != null && saveRequest != null && dataResponse != null) {
      const onFailure = (error) => {
        //console.log("bitacora", error);
      };
      const onSuccess = ({ data }) => {
        //console.log("bitacora", data);
      };

      fetchBitacora(
        mail,
        deviceWeb,
        fechaActualEnFormato,
        key,
        saveRequest,
        dataResponse,
        "Horarios",
        VERSION_APP,
        employeeId,
        brandfiMarcaId,
        branchFiSucursalId,
        branchFiPaisId
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  // config de dias de la semana
  const WEEKDAYS_CONFIG = {
    LUN: {
      label: "LUN",
      dia: "Lunes",
      entrada: "fc_horario_entrada_lunes",
      salida: "fc_horario_salida_lunes",
    },
    MAR: {
      label: "MAR",
      dia: "Martes",
      entrada: "fc_horario_entrada_martes",
      salida: "fc_horario_salida_martes",
    },
    MIE: {
      label: "MIE",
      dia: "Miercoles",
      entrada: "fc_horario_entrada_miercoles",
      salida: "fc_horario_salida_miercoles",
    },
    JUE: {
      label: "JUE",
      dia: "Jueves",
      entrada: "fc_horario_entrada_jueves",
      salida: "fc_horario_salida_jueves",
    },
    VIE: {
      label: "VIE",
      dia: "Viernes",
      entrada: "fc_horario_entrada_viernes",
      salida: "fc_horario_salida_viernes",
    },
    SAB: {
      label: "SAB",
      dia: "Sabado",
      entrada: "fc_horario_entrada_sabado",
      salida: "fc_horario_salida_sabado",
    },
    DOM: {
      label: "DOM",
      dia: "Domingo",
      entrada: "fc_horario_entrada_domingo",
      salida: "fc_horario_salida_lunes_domingo",
    },
  };

  const renderWeekSelector = () => {
    // identificar semana actual
    const isCurrentWeek = selectedOption === currentWeekNumber;
    const isPreviousWeek = selectedOption === previousWeekNumber;
    const isNextWeek = selectedOption === nextWeekNumber;

    // determinar botones a deshabilitar
    const disableLeftButton = isPreviousWeek;
    const disableRightButton = isNextWeek;

    // determinar semana a mostrar
    let weekNumber = currentWeekNumber;

    if (isPreviousWeek) {
      weekNumber = previousWeekNumber;
    } else if (isNextWeek) {
      weekNumber = nextWeekNumber;
    }

    return (
      <div className="button-felchas-select-semana">
        <button
          className="button-select-semana-horarios"
          onClick={() => setselectedOption(isCurrentWeek ? previousWeekNumber : currentWeekNumber)}
          disabled={disableLeftButton}
        >
          <ArrowBackIosNewSharpIcon />
        </button>

        <div className="text-semana-item-button-select">
          <CalendarIcon />
          <p> Semana {weekNumber} </p>
        </div>

        <button
          className="button-select-semana-horarios"
          onClick={() => setselectedOption(isCurrentWeek ? nextWeekNumber : currentWeekNumber)}
          disabled={disableRightButton}
        >
          <ArrowForwardIosSharpIcon />
        </button>
      </div>
    );
  };

  const renderDaySelector = () => {
    return (
      <div className="container-button-search">
        <div className="content-button-days">
          {Object.keys(WEEKDAYS_CONFIG).map((dayKey) => (
            <BtnPill
              key={dayKey}
              label={WEEKDAYS_CONFIG[dayKey].label}
              value={dayKey}
              isActive={changeDate === dayKey}
              onClick={setChangeDate}
              className={`button-days ${changeDate === dayKey && "active"}`}
              disabled={isLoading || listEmpleados.length === 0}
            />
          ))}
        </div>

        {/* Search Input */}
        <div className="content-box-filter">
          <Input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            prefix={<img src={icons.search} alt="Buscar producto" className="search-img" />}
            allowClear
            onClear={() => setSearchTerm("")}
            placeholder="Buscar por nombre"
            className="input-buscador-horarios"
            disabled={isLoading || listEmpleados.length === 0}
          />
        </div>
      </div>
    );
  };

  const renderScheduleContent = () => {
    // Render schedule for selected day
    const selectedDay = WEEKDAYS_CONFIG[changeDate];
    return (
      <div className="container-table-horarios">
        <ListaEmpleadosHoras
          week={currentWeekNumber}
          horarios={listEmpleados}
          entrada={selectedDay.entrada}
          salida={selectedDay.salida}
          semana={selectedOption}
          dia={selectedDay.dia}
          isLoading={isLoading}
          searchTerm={searchTerm}
        />
      </div>
    );
  };

  return (
    <div className="container-body-horarios">
      <Card className="horarios-card bg-white">
        <header className="reportes-card-header">
          <h2 className="reportes-card-title">Horarios</h2>
        </header>

        <div className="container-info-body-horarios">
          <div className="info-body-horarios">
            <div className="text-info-horarios">Tienda</div>
            <div className="text-data-horarios">{branchFcNombre}</div>
          </div>

          <div className="info-body-horarios">
            <div className="text-info-horarios">Semana</div>
            <div className="text-data-horarios">
              <span className="accent">
                {currentWeekNumber} {""}
              </span>{" "}
              {""}
              {""} {""} {weekStartDate.format("DD/MM/YYYY")}
              {""} - {""}
              {weekEndDate.format("DD/MM/YYYY")}
            </div>
          </div>
        </div>
      </Card>

      <div className="container-body-horarios-content">
        {/* selector de semanas */}
        <div className="text-data-horarios-weeks">{renderWeekSelector()}</div>

        {/* table */}
        <div className="bottom-section bg-white">
          {renderDaySelector()}

          {renderScheduleContent()}
        </div>
      </div>
    </div>
  );
};
